<template>
  <div class="introbox">
    <div class="avatar" @click="toProfilePage">
      <img class="avatarImg" :src="userDetail.avatar" />
      <!-- <img class="avatarImg" src="https://wangsu-image.rings.tv/images/2020/6/4/19/7b9d84d752dd4564942d77ee972f9fad" /> -->
    </div>
    <div class="nameArea" @click="toProfilePage" lang="en" dir="ltr">
        <div class="iconArea">
            <img class="iconImg levelIcon" :src="iconBackImg.levelBack">
            <img class="iconImg" :src="iconBackImg.vipBack" v-if="!!iconBackImg.vipBack">
            <img class="iconImg" :src="iconBackImg.verifyBack" v-if="!!iconBackImg.verifyBack">
            <div class="levelnum">{{userIconInfo.level}}</div>
        </div>
        {{userDetail.name}}
    </div>
    <p class="idtext" @click="toProfilePage">Loops live ID: {{userDetail.uid}}</p>
    <!-- <div class="followBtn" :class="!userDetail.following?'followBtnActive':'followBtnUnactive'" @click="followUser" v-if="!isHostSelf">{{userDetail.following? langText["following"] : langText["follow"]}}</div> -->
    <section v-if="hostHaveShowTime" class="timeArea">
    <div class="titleLine">
      <span>{{langText["countdown"]}}</span>
    </div>
    <div class="timeBoxArea" v-if="isArab">
      <div class="numberBox">{{timeArr.days[1]}}</div>
      <div class="numberBox">{{timeArr.days[0]}}</div>
      <div class="decatebox">:</div>
      <div class="numberBox">{{timeArr.hours[1]}}</div>
      <div class="numberBox">{{timeArr.hours[0]}}</div>
      <div class="decatebox">:</div>
      <div class="numberBox">{{timeArr.minutes[1]}}</div>
      <div class="numberBox">{{timeArr.minutes[0]}}</div>
      <div class="decatebox">:</div>
      <div class="numberBox secondNum">{{timeArr.seconds[1]}}</div>
      <div class="numberBox secondNum">{{timeArr.seconds[0]}}</div>
    </div>
    <div class="timeBoxArea" v-else>
      <div class="numberBox">{{timeArr.days[0]}}</div>
      <div class="numberBox">{{timeArr.days[1]}}</div>
      <div class="decatebox">:</div>
      <div class="numberBox">{{timeArr.hours[0]}}</div>
      <div class="numberBox">{{timeArr.hours[1]}}</div>
      <div class="decatebox">:</div>
      <div class="numberBox">{{timeArr.minutes[0]}}</div>
      <div class="numberBox">{{timeArr.minutes[1]}}</div>
      <div class="decatebox">:</div>
      <div class="numberBox secondNum">{{timeArr.seconds[0]}}</div>
      <div class="numberBox secondNum">{{timeArr.seconds[1]}}</div>
    </div>
    <div class="timetextBox">
      <div class="timeText">{{langText["day"]}}</div>
      <div class="timeText">{{langText["hour"]}}</div>
      <div class="timeText">{{langText["minute"]}}</div>
      <div class="timeText">{{langText["second"]}}</div>
    </div>
    </section>
    <section v-else>
      <div class="noTimeDescArea">
        <p class="noTimeDesc">{{isArab? userDetail.introduction_ar : userDetail.introduction}}</p>
      </div>
    </section>
    <div class="subBtn" :class="!userDetail.subscribed?'btnActive':'btnUnactive'" @click="subscribeUser(true)" v-if="!isHostSelf">{{!userDetail.subscribed?langText["subBtnText1"]:langText["subBtnText2"]}}</div>
    <!-- <div class="cancelBtn" @click="subscribeUser(false)" v-if="!isHostSelf">{{langText["subBtnText2"]}}></div> -->
<!--    <div class="titleLine2">
      <span>{{langText["recommendText"]}}</span>
    </div>
    <div class="recommendBox">
      <div class="recommendList">
          <div class="recommendItem" v-for="(item, index) in detailData.recommend" v-bind:key="index">
        <div class="recommendImgBox" @click="getHostInfo(item,index)">
          <img alt="" class="recommendImg" :src="item.avatar">
          <div class="liveIcon" v-if="!!item.ssid">LIVE</div>
        </div>
        <div class="recommendName" @click="getHostInfo(item)">{{item.name}}</div>
      </div>
      <div class="recommendItem" @click="getMore">
        <div class="moreImgBox">
          <img alt="" class="moreImg" src="./../assets/iconmore@2x.png">
        </div>
        <div class="recommendName" style="color:rgb(177,179,191)">More</div>
      </div>
      </div>
    </div>-->

  </div>
</template>

<script>
import {_di} from './../common/js/di';
import {lang} from './../language/kol';
import ic_member_tops4 from "./../assets/xxh/ic_member_tops4.9.png";
import ic_member_tops3 from "./../assets/xxh/ic_member_tops3.9.png";
import ic_member_tops2 from "./../assets/xxh/ic_member_tops2.9.png";
import ic_member_tops1 from "./../assets/xxh/ic_member_tops1.9.png";
import icn_vip1 from "./../assets/xxh/icn_vip1.png";
import icn_vip2 from "./../assets/xxh/icn_vip2.png";
import icn_vip3 from "./../assets/xxh/icn_vip3.png";
import icn_vip4 from "./../assets/xxh/icn_vip4.png";
import verify_1 from "./../assets/xxh/ic_partner.png"; //yellow
import verify_2 from "./../assets/xxh/ic_certification.png"; //red
import verify_3 from "./../assets/xxh/ic_verify_low.png"; //green
export default {
  name: "IntroComponent",
  props: {
    detailData: {
        name: "",
        uid: "",
        avatar: "",
        level: "",
        subscribed: false,
        following: false,
        next_live_time: '',
        introduction: '',
        introduction_ar: '',
        recommend: [],
    },
  },
  watch: {
    detailData(newValue,oldValue){
        this.userDetail = newValue;
        this.getTimeArr(newValue.next_live_time);
        this.hostHaveShowTime = this.showHostTime(newValue.next_live_time);
        //  this.hostHaveShowTime = true;
    }
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      baseUrl: "",
      langType: "en",
      token: "",
      userId: "",
      host_id: "",
      langType: "",
      langText: {},
      live_time: "",
      isHostSelf: false,
      isArab: false,
      hostHaveShowTime: false,
      timeArr: {
        seconds: [0, 0],
        minutes: [0, 0],
        hours: [0, 0],
        days: [0, 0]
      },
      userDetail: {
        name: "",
        uid: "",
        avatar: "",
        level: "",
        subscribed: false,
        following: false,
      },
      userIconInfo: {
        level: "",
        role: "",
        vip: "",
        privileges: [],
      },
      iconBackImg : {
        levelBack: "",
        vipBack: "",
        verifyBack: "",
      },
    };
  },
  created() {

  },
  mounted() {
    this.baseUrl = process.env.BASEURL;
    this.kolurl = process.env.KOLURL;
    this.userId = this.getUrlParam("userId") || 1002813;
    this.host_id = this.getUrlParam("hostId") || 1002812;
    this.token = this.getUrlParam("token") || "";
    this.langType = this.getUrlParam('lang') === 'ar' ? 'ar' : 'en';
    this.langText = lang[this.langType];
    this.isArab = this.langType == "ar"?true: false;
    // console.log(this.detailData)

    // this.initUserInfo();
    this.getUserIconInfo();
     if(this.host_id == this.userId){
        this.isHostSelf = true;
    }
    //di打点相关
    this.eventTrack = {
        kol_follow: _di('kol.follow',42623),
        kol_subsribe: _di('kol.subsribe',42624),
        kol_subsribe_cancel: _di('kol.subsribe.cancel',42625),
        kol_recommend: _di('kol.recommend',42630),
    }

  },
  methods: {
    initUserInfo(data) {
      this.userDetail = data;
      this.getTimeArr(1586486759);
    },
    getHostInfo(info,index){
      //打点
        this.eventTrack.kol_recommend({
            "uid": this.userId,
            "host_id": this.host_id,
            "num": index,
            "to_id": info.uid,
        });
      if(!!info.ssid){
        var linkurl = encodeURI("loopsmozat://broadcast/openVideo?cid="+info.uid+"&sid="+info.ssid);
        console.log(linkurl)
        window.location.href = linkurl;
      }else{
        this.$emit("changeHost",info.uid);
      }
    },
    getMore(){
      this.$router.push({
            path: '/kolupcoming',
            query: {
                userId: this.userId,
                hostId: this.host_id,
                lang: this.langType,
                token: this.token
            },
        });
    },
    getUserIconInfo() {
      var url = this.baseUrl + "/profile/" + this.host_id;
      var params = {
        uid: this.userId,
        token: this.token,
      };
      this.$axios.get(url, { params: params }).then(response => {
        //    console.log(response.data);
        var resData = response.data;
        // console.log(resData);
        this.userIconInfo = resData;
        this.iconBackImg.levelBack = this.getLevelBack(resData.level);
        this.iconBackImg.vipBack = this.getVipBack(resData.vip);
        var privilegeTypeArr = resData.privileges || [];
        var privilegeType = false;
        for(var item of privilegeTypeArr){
            if (item.type == 13) {
                privilegeType = true;
            }
        }
        this.iconBackImg.verifyBack = this.getVerifyBack(resData.role, resData.verified, privilegeType);
      });
    },
    getLevelBack(level) {
       if (level > 69) {
            return ic_member_tops4;
        } else if (level > 39) {
            return ic_member_tops3;
        } else if (level > 9) {
            return ic_member_tops2;
        } else {
            return ic_member_tops1;
        }
    },
    getVipBack(vipLevel) {
       if (vipLevel == 1) {
           return icn_vip1;
        } else if (vipLevel == 2) {
            return icn_vip2;
        } else if (vipLevel == 3) {
            return icn_vip3;
        } else if (vipLevel == 4) {
            return icn_vip4;
        } else {
            return null;
        }
    },
    getVerifyBack(role, verify, privilege) {
       if (role == 1) {
            return verify_1;
        } else if (!!verify) {
            return verify_2;
        }  else if (!!privilege) {
            return verify_3;
        }else {
            return null;
        }
    },
    getLandInfo() {
      var url = this.kolurl + "/kol/landing-info";
      var params = {
        host_id: this.host_id,
        uid: this.userId,
        token: this.token
      };
      this.$axios.get(url, { params: params }).then(response => {
           console.log(response.data);
        var resData = response.data;
        this.userDetail.subscribed = resData.subscribed;
        this.userDetail.following = resData.following;
        this.hostHaveShowTime = this.showHostTime(resData.next_live_time);

      });
    },
    showHostTime(time) {
       var nowtime = (new Date().getTime())/1000;
       if(time > nowtime){
           return true
       }else{
           return false
       }
    },
    getTimeArr(val) {
      var timestamp = Date.parse(new Date());
      timestamp = timestamp/1000;
      var timestart = val;
      if (timestamp < timestart) {
        var setInter1 = setInterval(() => {
          timestamp = Date.parse(new Date());
          timestamp = timestamp/1000;
          if (timestamp < timestart) {
            this.timeArr = this.formatSeconds((timestart - timestamp));
          } else {
            clearInterval(setInter1);
          }
        }, 1000);
      }
    },
    subscribeUser(isSubBtn) {
      var params = {
        host_id: this.host_id,
        uid: this.userId
      };
      if(this.userDetail.subscribed) {
        //打点
        this.eventTrack.kol_subsribe_cancel({
            "user_id": this.userId,
            "host_id": this.host_id,
        });
      }else{
          //打点
        this.eventTrack.kol_subsribe({
            "user_id": this.userId,
            "host_id": this.host_id,
        });
      }
      var postUrl = this.userDetail.subscribed ? "/kol/landing-unsubscribe" : "/kol/landing-subscribe";
      var wholeUrl = this.kolurl + postUrl + "?uid=" + this.userId + "&token=" + this.token;
      this.$axios.post(wholeUrl, params).then(response => {
        var resData = response.data;
        console.log(resData);
        this.getLandInfo();
        // this.$router.push({
        //     path: '/kolupcoming',
        //     query: {
        //         userId: this.userId,
        //         hostId: this.host_id,
        //         lang: this.langType,
        //         token: this.token
        //     },
        // });
      });
    },
    followUser() {
      var followParams = {
        target_id: this.host_id,
        uid: this.userId
      };
      console.log(followParams);
      var postUrl = !this.userDetail.following ? "/friendship/follow" : "/friendship/unfollow";
      var wholeUrl = this.baseUrl + postUrl + "?uid=" + this.userId + "&token=" + this.token;
      this.$axios.post(wholeUrl, followParams ).then(response => {
        var resData = response.data;
        console.log(resData);
        this.getLandInfo();
         //打点
        this.eventTrack.kol_follow({
            "user_id": this.userId,
            "host_id": this.host_id,
            "type": this.userDetail.following? 2 : 1,
        });
      });
    },
    toProfilePage() {
      var linkurl = encodeURI("loopsmozat://util/openChannelprofile?cid=0&uid="+ this.host_id);
      window.location.href = linkurl;
    },
    pad(str) {
      return +str >= 10 ? [Math.floor(str / 10), str % 10] : [0, str];
    },
    formatSeconds(value) {
      var theTime = Math.floor(value); // 需要转换的时间秒
      var theTime1 = 0; // 分
      var theTime2 = 0; // 小时
      var theTime3 = 0; // 天
      if (theTime > 60) {
        theTime1 = Math.floor(theTime / 60);
        theTime = Math.floor(theTime % 60);
        if (theTime1 > 60) {
          theTime2 = Math.floor(theTime1 / 60);
          theTime1 = Math.floor(theTime1 % 60);
          if (theTime2 > 24) {
            //大于24小时
            theTime3 = Math.floor(theTime2 / 24);
            theTime2 = Math.floor(theTime2 % 24);
          }
        }
      }
      return {
        seconds: this.pad(theTime),
        minutes: this.pad(theTime1),
        hours: this.pad(theTime2),
        days: this.pad(theTime3)
      };
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.timeArea{
  margin-bottom: 0.2rem;
}
.introbox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.avatar {
  width: 0.64rem;
  height: 0.64rem;
  border-radius: 0.32rem;
  margin-top: 0.3rem;
  margin-bottom: 0.1rem;
}
.avatarImg {
  width: 0.64rem;
  height: 0.64rem;
  border-radius: 0.32rem;
  object-fit: cover;
}
.nameArea {
  height: 0.24rem;
  line-height: 0.24rem;
  color: rgb(59, 59, 63);
  font-size: 0.14rem;
  font-weight: bolder;
  display: flex;

}
.iconArea{
    /* width: 0.8rem; */
    height: 0.24rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 0.05rem;
    /* background: pink; */
    position: relative;
}
.levelnum{
   position: absolute;
   line-height: 0.15rem;
   color: #fff;
   font-size: 0.1rem;
   height: 0.15rem;
   width: 0.18rem;
   text-align: center;
   left: 0.2rem;
   top:0.04rem;
}
.iconImg{
    height: 0.15rem;
    margin-left: 0.05rem;
}
.levelIcon{

}
.idtext {
  height: 0.24rem;
  line-height: 0.24rem;
  color: rgb(171, 173, 186);
  font-size: 0.12rem;
}
.titleLine {
  height: 0.24rem;
  line-height: 0.24rem;
  color: rgb(171, 173, 186);
  font-size: 0.12rem;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}
.titleLine::before {
  content: "";
  display: inline-block;
  width: 0.7rem;
  margin: 0.04rem 0.05rem;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.titleLine::after {
  content: "";
  display: inline-block;
  width: 0.7rem;
  margin: 0.04rem 0.05rem;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.timeBoxArea {
  width: 2.15rem;
  height: 0.33rem;
  /* background: pink; */
  display: flex;
  justify-content: space-between;
  color: rgb(59, 59, 63);
  margin: 0 auto;
}
.numberBox {
  width: 0.2rem;
  height: 0.31rem;
  /* border: 1px solid rgb(226, 226, 226); */
  text-align: center;
  line-height: 0.31rem;
  font-size: 0.2rem;
  position: relative;
}
.numberBox:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid rgb(226, 226, 226);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 200%;
    height: 200%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: left top;
    transform-origin: left top;
}
.secondNum {
  color: rgb(233, 50, 123);
}
.decatebox {
  height: 0.33rem;
  line-height: 0.33rem;
  font-size: 0.18rem;
  color: rgb(177, 179, 191);
}
.timetextBox {
  width: 2.15rem;
  height: 0.16rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.timeText {
  text-align: center;
  width: 0.5rem;
  color: rgb(171, 173, 186);
  font-size: 0.1rem;

}
.subBtn {
  width: 2.2rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  line-height: 0.4rem;
  text-align: center;
  font-size: 0.15rem;
  /* margin-top: 0.22rem; */
}
.cancelBtn {
  height: 0.2rem;
  line-height: 0.2rem;
  font-size: 0.12rem;
  color: rgb(188, 189, 201);
  margin-top: 0.15rem;
}
.followBtn {
  width: 1.1rem;
  height: 0.28rem;
  border-radius: 0.16rem;
  line-height: 0.28rem;
  text-align: center;
  font-size: 0.13rem;
  margin-top: 0.1rem;
  font-weight: bolder;
}

.followBtnActive {
  color: rgb(233, 50, 123);
  font-weight: bolder;
  box-shadow: 0 2.5px 5px rgba(233, 50, 123, 0.3);
  background: #fff;
  border: 1px solid rgb(233, 50, 123);
}
.followBtnUnactive {
  color: rgb(182, 182, 183);
  font-weight: bolder;
  box-shadow: 0 2.5px 5px rgba(207,207,207, 0.3);
  border: 1px solid rgb(220, 220, 220);
  /* background: linear-gradient(rgb(214, 214, 214), rgb(224, 223, 223)); */
}
.btnActive {
  color: #fff;
  font-weight: bolder;
  box-shadow: 0 2.5px 7.5px rgba(233, 50, 123, 0.4);
  background: linear-gradient(rgb(233, 50, 123), rgb(239, 36, 152));
}
.btnUnactive {
  color: rgb(182, 182, 183);
  font-weight: bolder;
  box-shadow: 0 2.5px 7.5px rgba(183, 183, 183, 0.4);
  background: linear-gradient(rgb(214, 214, 214), rgb(224, 223, 223));
}
.noTimeDescArea{
  width: 3.35rem;
  padding: 0.2rem 0;
}
.noTimeDesc{
  line-height: 0.2rem;
  font-size: 0.15rem;
  color: rgb(59, 59, 63);
  text-align: center;
}
.titleLine2 {
  height: 0.24rem;
  line-height: 0.24rem;
  color: rgb(59,59,63);
  font-size: 0.15rem;
  margin-top: 0.3rem;
  margin-bottom: 0.2rem;
}
.titleLine2::before {
  content: "";
  display: inline-block;
  width: 0.7rem;
  margin: 0.04rem 0.05rem;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.titleLine2::after {
  content: "";
  display: inline-block;
  width: 0.7rem;
  margin: 0.04rem 0.05rem;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.recommendBox{
  width: 3.75rem;
  overflow-x: auto;
  height: 0.94rem;

  /* padding: 0 0.15rem; */
}
.recommendList {
  display: flex;
  padding: 0 0.15rem;
}
.recommendItem{
  width: 0.8rem;
  height: 0.92rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.05rem;
  border: 1px solid rgb(237, 235, 235);
  margin: 0 0.05rem;
}
.recommendImgBox{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.1rem;
}
.recommendImg{
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  pointer-events:none;
}
.liveIcon{
  width: 0.35rem;
  height: 0.14rem;
  line-height: 0.14rem;
  text-align: center;
  border-radius: 0.07rem;
  background: rgb(115,181,34);
  color: #fff;
  font-size: 0.1rem;
   margin-top: -0.08rem;
}
.recommendName{
  width: 0.8rem;
  height: 0.18rem;
  color:rgb(59, 59, 63);
  font-size: 0.12rem;
  line-height: 0.18rem;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  margin-top: 0.07rem;
  text-align: center;
}
.moreImgBox{
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2.5px 7.5px rgba(233, 50, 123, 0.4);
  background: linear-gradient(rgb(233, 50, 123), rgb(239, 36, 152));
  margin-top: 0.2rem;
}
.moreImg{
  width: 0.32rem;
  pointer-events:none;
}
</style>



// WEBPACK FOOTER //
// src/components/KolIntro.vue